import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { ArrowLeft } from 'lucide-react';
import RouteEditorPanel from '../components/RouteEditorPanel';

export default function AdminRouteEditor() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-gray-50">
      <header className="bg-white border-b">
        <div className="max-w-[1200px] mx-auto px-4 py-4 flex items-center gap-4">
          <Button variant="ghost" size="sm" onClick={() => navigate(-1)} data-testid="route-editor-back-btn">
            <ArrowLeft className="w-4 h-4 mr-1" />Назад
          </Button>
          <div>
            <h1 className="text-xl font-bold">Редактор маршрута</h1>
            <p className="text-xs text-gray-500">Визуальный порядок точек для Telegram-бота логистики</p>
          </div>
        </div>
      </header>
      <div className="max-w-[1200px] mx-auto px-4 py-6">
        <RouteEditorPanel />
      </div>
    </div>
  );
}
